
export type MarkNotificationAsRead200BasicInfoType = typeof MarkNotificationAsRead200BasicInfoType[keyof typeof MarkNotificationAsRead200BasicInfoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MarkNotificationAsRead200BasicInfoType = {
  LIKE: 'LIKE',
  REPLY: 'REPLY',
  RETWEET: 'RETWEET',
  FOLLOW: 'FOLLOW',
  MENTION: 'MENTION',
} as const;
